module.exports = __webpack_public_path__ + "img/icon_m_send.b38a65c9.svg";